import * as React from 'react';

import {DUE_UNIT_DAYS_ID} from 'nutshell-core/date-time/delays';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';

import type {TimespanInput} from 'nutshell-graphql-types';

import {OverdueDurationInput} from './overdue-duration-input';

type Props = {
    overdueDuration: TimespanInput | null | undefined;
    onOverdueDurationChange: (arg1?: TimespanInput | null | undefined) => void;
};

export class OverdueDurationPicker extends React.PureComponent<Props> {
    render() {
        return (
            <ConditionalCheckboxInput
                onChange={this.handleToggle}
                label='Mark leads overdue if they remain in this stage for more than…'
                checked={Boolean(this.props.overdueDuration)}
            >
                {this.props.overdueDuration ? (
                    <OverdueDurationInput
                        overdueDuration={this.props.overdueDuration}
                        onOverdueDurationChange={this.props.onOverdueDurationChange}
                    />
                ) : null}
            </ConditionalCheckboxInput>
        );
    }

    handleToggle = () => {
        // if (this.props.overdueDuration.timespan) {
        if (this.props.overdueDuration) {
            // If we currently have a overdueDuration, set value to null
            this.props.onOverdueDurationChange(null);
        } else {
            // Not currently active, so give a default value
            const defaultValue = {
                timespan: 5,
                unit: DUE_UNIT_DAYS_ID,
            } as const;

            this.props.onOverdueDurationChange(defaultValue);
        }
    };
}
